import { BadgeItem } from 'src/common/interfaces';
import { StyledBadgeDescription, StyledBadgeImageContainer, StyledBadgeItemContainer, StyledBadgeTextContainer, StyledBadgeTitle } from 'src/features/badges/components/badge/badge.styles';
interface Props {
  badge: BadgeItem;
}
export const Badge = ({
  badge
}: Props) => <StyledBadgeItemContainer data-sentry-element="StyledBadgeItemContainer" data-sentry-component="Badge" data-sentry-source-file="badge.tsx">
    <StyledBadgeImageContainer data-sentry-element="StyledBadgeImageContainer" data-sentry-source-file="badge.tsx">
      <img src={`https://assets.tryhackme.com${badge.image}`} alt={badge.description} loading="lazy" />
    </StyledBadgeImageContainer>
    <StyledBadgeTextContainer data-sentry-element="StyledBadgeTextContainer" data-sentry-source-file="badge.tsx">
      <StyledBadgeTitle data-sentry-element="StyledBadgeTitle" data-sentry-source-file="badge.tsx">{badge.title}</StyledBadgeTitle>
      <StyledBadgeDescription data-sentry-element="StyledBadgeDescription" data-sentry-source-file="badge.tsx">{badge.description}</StyledBadgeDescription>
    </StyledBadgeTextContainer>
  </StyledBadgeItemContainer>;